import { withRouter } from "react-router-dom";
import { withNamespaces } from "react-i18next";
import { Button } from "reactstrap";
import Alert from "../../../alert";
import bottyCustomizeIcon from '../../../../../../../../assets/images/ai-onboarding/botty-customize.svg'

const Requirements = ({
    t,
    onNextButtonClicked
}) => {
    return (
        <>
            <Alert 
                icon={bottyCustomizeIcon}
                title='Please customize your platform'
                message='Please make sure that the tasks have been completed.'
            />

            <div className="ai-onboarding-content-body">
                <div className="requirements-desc">
                    <div className="desc-group">
                        <ol>
                            <li>
                                <div>
                                    <span className="desc-title">1. {t('Landing page')}</span>
                                    <p className="desc-info">
                                        {t("Customize the page for supplier reports according to your company's corporate design requirements. This page will be seen by your suppliers.")}
                                    </p>
                                </div>
                                {/* <Button outline color="primary" size="sm">{t('Check')}</Button> */}
                            </li>
                            
                            <li>
                                <div>
                                    <span className="desc-title">2. {t('Responsible Person')}</span>
                                    <p className="desc-info">
                                        {t("You can define the authorisation concept in User Management. Here are the role descriptions.")}
                                    </p>
                                </div>
                                {/* <Button outline color="primary" size="sm">{t('Check')}</Button> */}
                            </li>

                            <li>
                                <div>
                                    <span className="desc-title">3. {t('Risk Matrix')}</span>
                                    <p className="desc-info">
                                        {t("Customize the risk matrix to the circumstances of your company. It is important that you select the damage limits correctly.")}
                                    </p>
                                </div>
                                {/* <Button outline color="primary" size="sm">{t('Check')}</Button> */}
                            </li>

                            <li>
                                <div>
                                    <span className="desc-title">4. {t('Entity Management')}</span>
                                    <p className="desc-info">
                                        {t("Manage and organize entities such as departments, teams, or external parties within the platform.")}
                                    </p>
                                </div>
                                {/* <Button outline color="primary" size="sm">{t('Check')}</Button> */}
                            </li>
                        </ol>
                    </div>

                    {/* <div className="desc-group">
                        <h6 className="desc-group-title">{t('Entity Management')}</h6>
                        <ol>
                            <li>
                                <div>
                                    <span className="desc-title">1. {t('Entity Management')}</span>
                                    <p className="desc-info">
                                        {t("Customize the page for supplier reports according to your company's corporate design requirements. This page will be seen by your suppliers.")}
                                    </p>
                                </div>
                                <Button outline color="primary" size="sm">{t('Check')}</Button>
                            </li>
                        </ol>
                    </div> */}
                </div>

                <div className="ai-onboarding-tab-actions">
                    <Button color="primary" onClick={onNextButtonClicked}>{t('Next')}</Button>
                </div>
            </div>
        </>
    )
}

export default withNamespaces()(
    withRouter(Requirements)
)